import register from 'ShopUiBundle/modules/app/registry';

// tslint:disable-next-line
register('gtm-data-layer-action', () => import(/* webpackMode: "lazy" */'./gtm-data-layer-action'));
